import request from 'utils/RequestManager';
import config from '../../config';

const backendURL = config.BACKEND_HOST;


export function getCategoriesStatistics(companyIds, selectedPlatform) {
    const params = new URLSearchParams();
    companyIds.forEach((id) => {
        params.append('companyIds', id);
    });
    params.append('platform', selectedPlatform);


    return request({
        method: 'GET',
        baseURL: backendURL,
        url: `/statistic/categories`,
        params,
    })
        .then(response => response.data);
}

export function getCompanyInfoStatistics(companyIds) {
    const params = new URLSearchParams();
    companyIds.forEach((id) => {
        params.append('companyIds', id);
    });

    return request({
        method: 'GET',
        baseURL: backendURL,
        url: `/statistic/company-info`,
        params,
    })
        .then(response => response.data);
}

export function getOperatorsWorksTimeData(parentCompanyId, startDate, endDate) {
    return request({
        method: 'GET',
        baseURL: backendURL,
        url: `/statistic/operators/works-time/${parentCompanyId}`,
        params: {
            startDate,
            endDate
        }
    })
        .then(response => response.data);
}

export function getPeakHoursStatistics(companyIds, selectedPlatform) {
    if (selectedPlatform === undefined) {
        selectedPlatform = null
    }
    const params = new URLSearchParams();
    params.append('platform', selectedPlatform);
    companyIds.forEach((id) => {
        params.append('companyIds', id);
    });

    return request({
        method: 'GET',
        baseURL: backendURL,
        url: '/statistic/conversations/peak-hours',
        params,
    })
        .then(response => response.data);
}

export function fetchOperatorListConversations(companyIds, status, platformId, selectedPlatform) {
    if (selectedPlatform === undefined) {
        selectedPlatform = null
    }
    const params = new URLSearchParams();
    params.append('status', status);
    params.append('platformId', platformId);
    params.append('platform', selectedPlatform);
    companyIds.forEach((id) => {
        params.append('companyIds', id);
    });

    return request({
        method: 'GET',
        baseURL: backendURL,
        url: '/companies/conversations',
        params,
    })
        .then(response => response.data);
}

export function fetchCompanyListConversationsForOwner(status, userId) {
    const params = new URLSearchParams();
    params.append('status', status);
    params.append('userId', userId);
    return request({
        method: 'GET',
        baseURL: backendURL,
        url: '/companies/conversations-for-owner',
        params,
    })
        .then(response => response.data);
}

export function fetchOperatorCompanyListConversations(companyIds, status = config.conversationStatuses.operatorProcessing) {
    const params = new URLSearchParams();
    params.append('status', status);
    companyIds.forEach((id) => {
        params.append('companyIds', id);
    });

    return request({
        method: 'GET',
        baseURL: backendURL,
        url: `/operators/conversations`,
        params,
    })
        .then(response => response.data);
}

export function fetchOperatorCompanyListConversationsForOwner(status = config.conversationStatuses.operatorProcessing) {
    const params = new URLSearchParams();
    params.append('status', status);

    return request({
        method: 'GET',
        baseURL: backendURL,
        url: `/operators/conversations`,
        params,
    })
        .then(response => response.data);
}

export function fetchConversationsWithMembers() {
    return request({
        method: 'GET',
        baseURL: backendURL,
        url: `/operators/company/conversations`,
    })
        .then(response => response.data);
}

export function getConversationDetails(conversationId) {
    return request({
        method: 'GET',
        baseURL: backendURL,
        url: `/conversations/${conversationId}/details`,
    })
        .then(response => response.data);
}

export function takeConversationForOperator(conversationId, operatorPlatformId) {
    return request({
        method: 'PATCH',
        baseURL: backendURL,
        url: `/conversations/${conversationId}/${operatorPlatformId}`,
    })
        .then(response => response.data);
}

export function endConversationForOperator(conversationId, silentMod) {
    return request({
        method: 'PATCH',
        baseURL: backendURL,
        url: `/conversations/end-by-operator/${conversationId}`,
        params: {
            silentMod
        }
    })
        .then(response => response.data);
}

export function forwardConversationForOperator(conversationId, newOperatorId, silentMod) {
    return request({
        method: 'PATCH',
        baseURL: backendURL,
        url: `/conversations/forward-by-operator/${conversationId}`,
        params: {
            newOperatorId,
            silentMod
        }
    })
        .then(response => response.data);
}

export function fetchConversationMessages(conversationId, offset = 0, limit = config.messagesPageDefaultSize) {
    return request({
        method: 'GET',
        baseURL: backendURL,
        url: `conversations/${conversationId}/messages`,
        params: {
            offset,
            limit,
        },
    })
        .then(response => response.data);
}

export function fetchOperatorConversationMessages(operatorConversationId) {
    return request({
        method: 'GET',
        baseURL: backendURL,
        url: `operator-conversations/${operatorConversationId}/messages`,
    })
        .then(response => response.data);
}

export function makeConversationMessagesSeen(conversationId) {
    return request({
        method: 'PATCH',
        baseURL: backendURL,
        url: `conversations/${conversationId}/seen/clear`,
    })
        .then(response => response.data);
}

export function getMessage(messageId) {
    return request({
        method: 'GET',
        baseURL: backendURL,
        url: `messages/${messageId}`,
    })
        .then(response => response.data);
}

export function sendChatMessage(conversationId, message, commentMessage) {
    return request({
        method: 'POST',
        baseURL: backendURL,
        url: `conversations/${conversationId}/messages`,
        data: message,
        params: {
            commentMessage
        }
    })
        .then(response => response.data);
}

export function moveConversationToManagedList(conversationId, userPlatformId, silentMod) {
    return request({
        method: 'GET',
        baseURL: backendURL,
        url: `conversations/${conversationId}/${userPlatformId}/move-to-managed-list`,
        params: {
            silentMod
        },
    })
        .then(response => response.data);
}

export function sendOperatorChatMessage(operatorId, conversationId, message) {
    return request({
        method: 'POST',
        baseURL: backendURL,
        url: `operators/${operatorId}/company/conversations/${conversationId}/messages`,
        data: message,
    })
        .then(response => response.data);
}

export function updateMessage(id, update) {
    return request({
        method: 'PATCH',
        baseURL: backendURL,
        url: `messages/${id}/seen`,
        data: update,
    })
        .then(response => response.data);
}

export function sendTypingMessage(conversationId, value) {
    const params = new URLSearchParams();
    params.append('conversationId', conversationId);
    params.append('value', value);

    return request({
        method: 'PATCH',
        baseURL: backendURL,
        url: `messages/typing`,
        params
    })
        .then(response => response.data);
}

export function deleteMessage(id) {
    return request({
        method: 'DELETE',
        baseURL: backendURL,
        url: `/messages/${id}`,
    })
        .then(response => response.data);
}

export function editMessage(id, newText) {
    return request({
        method: 'PUT',
        baseURL: backendURL,
        url: `/messages/${id}`,
        headers: {
            'Content-Type': 'text/plain'
        },
        data: newText,
    })
        .then(response => response.data);
}

export function endConversation(contactId) {
    const requestData = {
        method: 'POST',
        baseURL: backendURL,
        url: `/conversation/close/?userId=${contactId}`,
    };

    return request(requestData);
}


// new statistics

export function getAllRequestsToOperator(companyIds, selectedPlatform) {
    if (selectedPlatform === undefined) {
        selectedPlatform = null
    }
    const params = new URLSearchParams();
    params.append('platform', selectedPlatform);
    companyIds.forEach((id) => {
        params.append('companyIds', id);
    });

    return request({
        method: 'GET',
        baseURL: backendURL,
        url: '/statistic/all-requests-to-operator',
        params,
    })
        .then(response => response.data);
}

export function getTodaysRequestsToOperator(companyIds, selectedPlatform) {
    if (selectedPlatform === undefined) {
        selectedPlatform = null
    }
    const params = new URLSearchParams();
    params.append('platform', selectedPlatform);
    companyIds.forEach((id) => {
        params.append('companyIds', id);
    });

    return request({
        method: 'GET',
        baseURL: backendURL,
        url: '/statistic/todays-requests-to-operator',
        params,
    })
        .then(response => response.data);
}

export function getAllUnansweredRequests(companyIds, selectedPlatform) {
    if (selectedPlatform === undefined) {
        selectedPlatform = null
    }
    const params = new URLSearchParams();
    params.append('platform', selectedPlatform);
    companyIds.forEach((id) => {
        params.append('companyIds', id);
    });

    return request({
        method: 'GET',
        baseURL: backendURL,
        url: '/statistic/all-unanswered-requests',
        params,
    })
        .then(response => response.data);
}

export function getAllAnsweredRequests(companyIds, selectedPlatform) {
    if (selectedPlatform === undefined) {
        selectedPlatform = null
    }
    const params = new URLSearchParams();
    params.append('platform', selectedPlatform);
    companyIds.forEach((id) => {
        params.append('companyIds', id);
    });

    return request({
        method: 'GET',
        baseURL: backendURL,
        url: '/statistic/all-answered-requests',
        params,
    })
        .then(response => response.data);
}

export function getActiveRequestsToOperator(companyIds, selectedPlatform) {
    if (selectedPlatform === undefined) {
        selectedPlatform = null
    }
    const params = new URLSearchParams();
    params.append('platform', selectedPlatform);
    companyIds.forEach((id) => {
        params.append('companyIds', id);
    });

    return request({
        method: 'GET',
        baseURL: backendURL,
        url: '/statistic/all-active-requests',
        params,
    })
        .then(response => response.data);
}

export function getForwardedRequestsToOperator(companyIds, selectedPlatform) {
    if (selectedPlatform === undefined) {
        selectedPlatform = null
    }
    const params = new URLSearchParams();
    params.append('platform', selectedPlatform);
    companyIds.forEach((id) => {
        params.append('companyIds', id);
    });

    return request({
        method: 'GET',
        baseURL: backendURL,
        url: '/statistic/all-forwarded-requests',
        params,
    })
        .then(response => response.data);
}


// WEBPACK FOOTER //
// ./src/services/chat/api.js